<template>
  <tr class="boon-row">
    <td class="occupation">
      {{ $t(item.occupation) }}
    </td>
    <td class="company-info">
      <span>
        <router-link :to="{ name: 'EditCompany', params: { _id: company._id } }">
          {{ company.companyName }}
        </router-link>
      </span>
      <span class="slashed" v-if="company.registrationNumber">
        {{ company.registrationNumber }}
      </span>
    </td>
    <td class="company-info">
      <span v-if="item.personId">
        <router-link :to="{ name: 'EditPerson', params: { _id: person._id } }">
          {{ person.firstName }} {{ person.lastName }}
        </router-link>
      </span>
    </td>
    <td class="company-info">
      <span v-if="item.personId && person.phone">
        {{ person.phone }}
      </span>
    </td>
    <td class="company-info">
      <span v-if="person.email">
        <a :href="'mailto:' + person.email">
          {{ person.email }}
        </a>
      </span>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ViewProjectContactItem',
  data() {
    return {};
  },
  props: {
    item: {},
  },
  methods: {
    ...mapActions(['loadProject']),
  },
  computed: {
    ...mapGetters(['getCompany', 'getPerson', 'hasSimplePermissions']),
    company: function () {
      return this.getCompany(this.item.companyId);
    },
    person: function () {
      return this.getPerson(this.item.personId);
    },
  },
  components: {},
  mounted: async function () {
    if (this.$route.params._id) {
      this.project = await this.loadProject(this.$route.params._id);
    }
  },
  watch: {
    $route: async function (to, from) {
      console.log('EditProject::watch:', JSON.stringify(from), JSON.stringify(to));
      if (this.$route.params._id) {
        if (this.$route.params._id !== this.project._id) {
          this.project = await this.loadProject(this.$route.params._id);
        }
      }
    },
  },
};
</script>

<style scoped>
.boon-row {
  font-size: 8pt;
}

.slashed::before {
  content: '/';
}

.occupation {
  width: 30%;
  text-transform: uppercase;
  vertical-align: top;
}

td {
  border-bottom: 1px solid black;
  padding: 1mm 0mm;
  margin: 0px;
}

tr {
  cellspacing: 0px;
  cellpadding: 0px;
}

a {
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/project/ViewProjectContactItem.vue